import { lazy } from "react";
import Icon from "../components/Icon";

const Profile = lazy(() => import("../container/Profile"));
const ChangePassword = lazy(() => import("../container/ChangePassword"));
const AccessDenied = lazy(() => import("../container/Reseller/AccessDenied"));
const PurchaseOrder = lazy(() => import("../container/Reseller/PurchaseOrder"));
// const PurchaseList = lazy(() => import("../container/Reseller/PurchaseList"));
const PurchaseOrderView = lazy(() => import("../container/Reseller/PurchaseOrderView"));

const resellerRoutes = [
  {
    path: "/",
    exact: true,
    sidebar: true,
    permissions: ["BSS__PORTAL_CREATE_LEAD_ORDER"],
    title: "ثبت‌ سفارش خرید",
    iconTag: <Icon name={"deposits-list"} className={"drawerIcons large"} />,
    component: PurchaseOrder,
  },
  // {
  //   path: "/purchase-list",
  //   exact: true,
  //   sidebar: true,
  //   title: "لیست سفارش خرید",
  //   permissions: ["BSS__PORTAL_CREATE_LEAD_ORDER"],
  //   iconTag: <Icon name="pay-chart" className="drawerIcons large" />,
  //   component: PurchaseList,
  // },
  {
    path: "/purchase-list/view/:id",
    exact: true,
    title: "مشخصات سفارش خرید",
    iconTag: <Icon name="financial-chart" className="drawerIcons large" />,
    component: PurchaseOrderView,
  },
  {
    path: "/profile",
    exact: true,
    component: Profile,
  },
  {
    path: "/change-password",
    exact: true,
    component: ChangePassword,
  },
  {
    path: "/access-denied",
    exact: false,
    component: AccessDenied,
  },
];

export default resellerRoutes;
